import * as React from "react";
import { MatchPlace } from "../../../styles/Racelive";
import { Dropdown } from "antdv5";
import { DownOutlined } from "@ant-design/icons";
import { color } from "../../../styles/color";
import BackOutter1 from "./BackOutter1";
import BackOutter2 from "./BackOutter2";
import TrainingTop from "./TopTrainingBox";
import type { IGameTop, IGameDetail } from "../../../api_types";
import type { ITableData } from "../../../client_types";
import type { IPartialGameTop } from "../../../pages/Racelive";

interface IProps {
  isMatch: boolean;
  grade: ITableData<IGameDetail>;
  data: IPartialGameTop | IGameTop;
  fly: string | null;
  speed: string | null;
  gameName: string | null;
  typeList: {
    key: string;
    label: string;
  }[];
  matchDropdownList: {
    key: string;
    label: string;
  }[];
  typeListOnClick: (e: { key: string }) => void;
  matchListDropdownOnClick: (e: { key: string }) => void;
  backPercent: (total: number, now: number) => number;
}

const handleMetresPerMin = (m: string | number | any): number => {
  if (typeof m === "string") {
    return Number.parseInt(m) || 0;
  } else if (typeof m === "number") {
    return m;
  } else {
    return 0;
  }
};

const RaceLiveData = ({
  isMatch,
  typeList,
  typeListOnClick,
  matchDropdownList,
  matchListDropdownOnClick,
  gameName,
  data,
  grade,
  fly,
  speed,
  backPercent,
}: IProps) => {
  const hasCoordinates =
    data?.StringE_HMS !== "0°0′0″" && data?.StringN_HMS !== "0°0′0″";
  const metresPerMin = handleMetresPerMin(data.BasicMetresPerMin);
  const clockStop = data?.ClockStop.replace(/T/g, " ");
  const clockStart = data?.ClockStart.replace("T", " ");

  return (
    <>
      <MatchPlace>
        <Dropdown
          menu={{ items: typeList, onClick: typeListOnClick }}
          trigger={["click"]}
        >
          <div className="matchLocation">
            {isMatch ? "比赛" : "训练"}
            <DownOutlined />
          </div>
        </Dropdown>
        <Dropdown
          menu={{
            items: matchDropdownList,
            onClick: matchListDropdownOnClick,
          }}
          trigger={["click"]}
        >
          <div
            className="expire"
            style={{
              color: `${color.primaryBlue}`,
              cursor: "pointer",
            }}
          >
            {gameName} <DownOutlined />
          </div>
        </Dropdown>
        {(() => {
          if (isMatch) {
            return (
              <ShowDateAndSpeed
                clockStop={clockStop}
                metresPerMin={metresPerMin}
              />
            );
          } else if (hasCoordinates) {
            return (
              <ShowDateAndSpeed
                clockStop={clockStop}
                metresPerMin={metresPerMin}
              />
            );
          } else {
            return <div className=""></div>;
          }
        })()}
      </MatchPlace>
      {(() => {
        if (isMatch) {
          return (
            <BackOutter1
              type={isMatch}
              totalBird={Number.parseInt(data.TotalBird)}
              nowCount={Number.parseInt(data.NowCount)}
              totalPage={grade.totalPage}
              fly={fly}
              speed={speed}
              clockStop={clockStop}
              clockStart={clockStart}
            />
          );
        } else if (hasCoordinates) {
          return (
            <BackOutter2
              type={isMatch}
              totalBird={Number.parseInt(data.TotalBird)}
              nowCount={Number.parseInt(data.NowCount)}
              totalPage={grade.totalPage}
              fly={fly}
              speed={speed}
              clockStop={clockStop}
              clockStart={clockStart}
            />
          );
        } else {
          return <TrainingTop type={isMatch} data={data as IGameTop} />;
        }
      })()}
    </>
  );
};

interface IShowDateAndSpeedProps {
  clockStop: string;
  metresPerMin: number;
}
const ShowDateAndSpeed = ({
  clockStop,
  metresPerMin,
}: IShowDateAndSpeedProps) => (
  <>
    <div className="expire">
      {metresPerMin === 0 ? `报道时间截止：${clockStop}` : ""}
    </div>
    <div className="expire">
      有效分速：
      {metresPerMin === 0 ? "无限制" : metresPerMin}
    </div>
  </>
);

export default RaceLiveData;
